import { render, staticRenderFns } from "./ProcessPrizeDraw.vue?vue&type=template&id=237ceb50"
import script from "./ProcessPrizeDraw.vue?vue&type=script&lang=js"
export * from "./ProcessPrizeDraw.vue?vue&type=script&lang=js"
import style0 from "./ProcessPrizeDraw.vue?vue&type=style&index=0&id=237ceb50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports